import React from 'react';
import Grid from '../responsive/Grid';
import '../css/Footer.scss';
import {ArrowHalfDown, Twitter, Youtube} from './Vectors';
import {ReactComponent as Logo} from '../assets/svg/footer_logo.svg';
import Router from '../router/Router';
import Button from './Button';
import GridLines from './GridLines';
import Breadcrumb from './Breadcrumb';
import Link from '../css/ui/Link';

export default class Footer extends React.Component<{data?:any}>
{
	scrollTop = () =>
	{
		Router.scrollTop();
	}

	render()
	{
		return (
			<React.Fragment>
				<Button className="scrollToTop" onClick={this.scrollTop}>
					<Grid skip={1} cols={3} breakpoints={{small: {cols:2, skip: 2}}}>
						<span className="label-right flex-middle">
							<ArrowHalfDown className="arrow"></ArrowHalfDown>
							<span className="actionLabel">{this.props.data.scrollTop.label}</span>
						</span>

					</Grid>
				</Button>
				<Breadcrumb></Breadcrumb>
				<footer>
					<Grid cols={4}>
						<Grid cols={1} breakpoints={{small: {cols: 2}}} className='logo padding'>
							<Logo></Logo>
						</Grid>
						<Grid cols={1} className='hide-small padding'>
							<ul className="links">
								{
									this.props.data.menu.map((e, i)=>{
										return (<li key={i}><Link to={Router.getByID(e['link'])}>{e['label']}</Link></li>)
									})
								}
							</ul>
						</Grid>
						<Grid cols={1} skip={1} breakpoints={{small: {cols: 4, skip: 0}}} className="followContainer" >
							<div className='flex flex-middle padding'>
								<span className='follow'>follow us on</span>
								<Button plain={true} url={this.props.data['social']['twitter']['url']} className='socialIcon'><Twitter></Twitter></Button>
								<Button plain={true} url={this.props.data['social']['youtube']['url']} className='socialIcon'><Youtube></Youtube></Button>
							</div>
						</Grid>
						<Grid cols={1} breakpoints={{small: {cols: 4}}} className='legal padding'>
							<ul>
								{
									this.props.data.legal.map((e, i)=>{
										return (<li className='small' key={i}><Link to={e.url || e.link} {...e}>{e['label']}</Link></li>)
									})
								}
							</ul>
						</Grid>
					</Grid>
					<span className='copyright padding'>{this.props.data.copyright.text}</span>
					<GridLines className="footerGridLines"></GridLines>
				</footer>
			</React.Fragment>
		)
	}
}